export const AlertViewMode = {
  INDIVIDUAL: 'individual',
  ITEM: 'item'
} as const;
export type AlertViewMode = (typeof AlertViewMode)[keyof typeof AlertViewMode];